/*eslint-disable*/
// @ts-nocheck
import {
  Breadcrumbs, Button, IconButton, Typography,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  useTheme,
  Box,
} from "@mui/material";
import React, { useEffect } from "react";
import { PageContent, PageHeader , RenderIf} from "@adl/smart-ui-library";
import { useAppSelector, useAppDispatch } from "@/hooks";
import {
  setSelectedCase,
  selectSelectedDocument,
  setSelectedDocument,
} from "@/redux/casesSlice";
import DefaultTemplate from "@/templates/DefaultTemplate/DefaultTemplate";

import { setSelectedTasks } from "@/redux/tasksSlice";
import Notifications from "@/components/Notifications";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { useMsal } from "@azure/msal-react";
import VaultIcon from "../../components/VaultIcon/VaultIcon";
import VaultTextLogo from "@/components/VaultTextLogo";
import { useNavigate } from "react-router-dom";
import { formatDate } from "@/utils";
import EditIcon from '@mui/icons-material/Edit';
import { access } from "fs";

const SelectedNonPCodePage = () => {
  const { instance } = useMsal();
  const theme = useTheme();
  const [rowData, setRowData] = React.useState<any[] | null>(null);

  const navigate = useNavigate();
  const appDispatch = useAppDispatch();
  const docProfile = useAppSelector(selectSelectedDocument);

  const onLogout = () => {
    instance.logout();
  };

  const onTaskBtnClick = () => {

    appDispatch(setSelectedTasks([]));
    navigate(`/tasks`);
  };

  const onHomeBtnClick = () => {

    appDispatch(setSelectedCase(null));
    navigate(`/`);
  };


  const onNonBtnClick = () => {
    appDispatch(setSelectedTasks([]));
    navigate(`/non-p-code`);
  };


  const editItem = () => {
    appDispatch(setSelectedDocument(docProfile));
    navigate(`/edit`);
  };

  const accessLevel = JSON.parse(sessionStorage.getItem('accessLevel')) || {};
  const uploadOwner = JSON.parse(sessionStorage.getItem('uploadOwner')) || false;

  useEffect(() => {
    console.log(docProfile)
    const rows = [
      {
        id: "Document Category",
        value: [
          {
            type: "category",
            label: docProfile?.category[0]?.categoryName,
            value: docProfile?.category[0]?.categoryName,
            param: docProfile?.category[0]?.categoryName,
          },
        ],
      },
      {
        id: "Market",
        value: [
          {
            type: "market",
            label: docProfile?.markets.map((name) => (
              name.market
            )).toString(),
            value: docProfile?.markets.map((name) => (
              name.market
            )).toString(),
            param: docProfile?.markets.map((name) => (
              name.market
            )).toString(),
          },
        ],
      },
      {
        id: "Account Industry",
        value: [
          {
            type: "accountIndustry",
            label: docProfile?.accountIndustry,
            value: docProfile?.accountIndustry,
            param: docProfile?.accountIndustry,
          },
        ],
      },
      {
        id: "Account subindustry",
        value: [
          {
            type: "accountSubIndustry",
            label: docProfile?.accountSubindustries.map((name) => (
              name.subindustryL1
            )).toString(),
            value: docProfile?.accountSubindustries[0]?.subindustryL1,
            param: docProfile?.accountSubindustries[0]?.subindustryL1,
          },
        ],
      },
      {
        id: "Industry practice",
        value: [
          {
            type: "industryPractice",
            label: docProfile?.industry,
            value: docProfile?.industry,
            param: docProfile?.industry,
          },
        ],
      },
      {
        id: "Functional practice",
        value: [
          {
            type: "functionalPractice",
            label: docProfile?.practices.map((name) => (
              name.practice
            )).toString(),
            value: docProfile?.practices[0]?.practice,
            param: docProfile?.practices[0]?.practice,
          },
        ],
      },
      {
        id: "Functional topic",
        value: [
          {
            type: "FunctionalTopic",
            label: docProfile?.functionalTopicsL1.map((name) => (
              name.functionalTopicL1
            )).toString(),
            value: docProfile?.functionalTopicsL1.map((name) => (
              name
            )),
            param: docProfile?.functionalTopicsL1[0]?.functionalTopicL1,
          },
        ],
      },
      {
        id: "Functional subtopic",
        value: [
          {
            type: "FunctionalSubTopic",
            label: docProfile?.functionalTopicsL2.map((name) => (
              name.functionalTopicL2
            )).toString(),
            value: docProfile?.functionalTopicsL2[0]?.functionalTopicL2,
            param: docProfile?.functionalTopicsL2[0]?.functionalTopicL2,
          },
        ],
      },
      {
        id: "Authors",
        value: [
          {
            type: "authors",
            label: docProfile?.authors?.join(", "),
            value: docProfile?.authors?.join(", "),
            param: docProfile?.authors?.join(", "),
          },
        ],
      },
    ];

    setRowData(rows);
  }, [docProfile]);
  return (
    <DefaultTemplate paddingTop={200}>
      <>
        <PageHeader
          logo={
            <VaultIcon width={40} height={40} handleClick={onHomeBtnClick} />
          }
          navigation={
            <>
              <Notifications />
              {accessLevel?.name !== 'NoAccess' &&

                <Button data-testid="tasks-button" onClick={onNonBtnClick}>
                  Non-P-Code Documents
                </Button>
              }
              <Button onClick={onTaskBtnClick}>Tasks</Button>
              <Button onClick={onLogout}>Logout</Button>
            </>
          }
          subHeader={
            <>
              <Breadcrumbs
                aria-label="breadcrumb"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <IconButton onClick={onHomeBtnClick}>
                  <HomeOutlinedIcon />
                </IconButton>
                <Button variant="text" onClick={onNonBtnClick}>
                  Non-P-Code Documents
                </Button>
                <Typography color="text.primary">
                  {docProfile?.fileNameOriginal}
                </Typography>
              </Breadcrumbs>

            </>
          }
        >
          <VaultTextLogo />
        </PageHeader>
        <PageContent>
          {accessLevel?.name !== 'NoAccess' ?


            (<Box style={{ width: '70%', marginLeft: '100px' }}>
              <div style={{ display: 'flex' }}>
                <h2 style={{ width: '80%' }}>
                  {docProfile?.fileNameOriginal}

                </h2>
                <div style={{ fontSize: '12px' }}>
                  <RenderIf isTrue={(uploadOwner && accessLevel?.canEditOwn) || accessLevel?.canEditAll}>

                    <IconButton style={{ fontSize: '14px' }} onClick={() => editItem()}>
                      <EditIcon /> Edit
                    </IconButton>
                    
                  </RenderIf>

                </div>
              </div>
              <p style={{ color: '#aaa', fontSize: '14px', marginBottom: '20px' }}>
                Uploaded on {formatDate(docProfile?.createdAt)}

              </p>
              <Typography variant="h6" sx={{ marginBottom: "15px" }}>
                Document Details
              </Typography>
              <TableContainer component={Box}>
                <Table
                  sx={{
                    border: `1px solid ${theme.palette.grey[300]}`,
                  }}
                >
                  <TableBody>
                    {rowData?.map((row) => {
                      return (
                        <TableRow
                          sx={{
                            "td, th": {
                              borderBottom: `1px solid ${theme.palette.grey[300]}`,
                            },
                          }}
                        >
                          <TableCell sx={{ width: "150px" }}>
                            <Typography variant="h3">{row.id}</Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                              {row.value?.map((item) => {
                                 if(item.label) { return <Chip label={item.label} /> }

                                 else return 
                    })}
                            </Box>
                          </TableCell>
                          <TableCell align="right">

                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>)
            :
            (<Box style={{ width: '70%', marginLeft: '100px' }}>
              You need access to view this page
            </Box>)
          }
        </PageContent>

      </>
    </DefaultTemplate>
  );
};

export default SelectedNonPCodePage;
